<template>
    <div class="modal fade" id="practice-switched-modal" tabindex="-1" ref="modalRef">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Practice switched</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    You are now viewing <strong>{{ practiceName }}</strong>.
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal">OK</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Modal } from 'bootstrap';

    export default {
        data() {
            return {
                modalInstance: null,
            };
        },
        computed: {
            practiceName() {
                return this.$store.state.practiceSwitchedNotice;
            },
        },
        mounted() {
            this.modalInstance = new Modal(this.$refs.modalRef, {});

            this.$watch('practiceName', (newVal) => {
                if (newVal) {
                    this.modalInstance.show();
                } else {
                    this.modalInstance.hide();
                }
            }, { immediate: true });

            this.$refs.modalRef.addEventListener('hidden.bs.modal', () => {
                if (this.practiceName) {
                    this.$store.dispatch('clearPracticeSwitchedNotice');
                }
            });
        },
    };
</script>
